import { render, staticRenderFns } from "./BusinessCenters.vue?vue&type=template&id=c4072a50&scoped=true&"
import script from "./BusinessCenters.vue?vue&type=script&lang=js&"
export * from "./BusinessCenters.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCenters.vue?vue&type=style&index=0&id=c4072a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4072a50",
  null
  
)

export default component.exports